import { FontEntry } from '../../types/font'

export const cabin: FontEntry = {
  displayName: 'Cabin',
  weights: {},
  variables: {
    normal: {
      file: 'Cabin-VariableFont_wdth,wght',
      extension: 'ttf',
      format: 'truetype',
      weightRange: [100, 900]
    },
    italic: {
      file: 'Cabin-Italic-VariableFont_wdth,wght',
      extension: 'ttf',
      format: 'truetype',
      weightRange: [100, 900]
    }
  },
  fallbackMetrics: {
    arial: {
      regular: {
        sizeAdjust: 93.86,
        ascentOverride: 102.81,
        descentOverride: 26.63,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 89.82,
        ascentOverride: 107.44,
        descentOverride: 27.83,
        lineGapOverride: 0
      }
    },
    roboto: {
      regular: {
        sizeAdjust: 95.24,
        ascentOverride: 101.33,
        descentOverride: 26.25,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 95.15,
        ascentOverride: 101.41,
        descentOverride: 26.27,
        lineGapOverride: 0
      }
    }
  }
}
